import { withCurrentParams } from 'actions/utils';
import { BROADCAST_DELETE_SOURCE } from 'actions/Types';
import { ATTENDEE_ROSTER_CHANGE, SOURCE_DELETE } from 'store/eventConstants';
import updateDeletedSourceInProgram from 'actions/Broadcast/scene/updateDeletedSourceInProgram';
import showNotification from '@shoflo/studio-redux/actions/notification/showNotification';
import { isMediaSource, isScreenPresenter } from 'utils/broadcastSourceHelper';

/**
 * @param {string} sourceId
 * @param {object} deleteParams data to help understand subsequent action to perform
 */
export default (sourceId, deleteParams) => {
  const getNotificationTitle = source => {
    if (isScreenPresenter(source)) {
      return 'Screen share';
    } else if (isMediaSource(source)) {
      return 'Content';
    }
    return 'Speaker';
  };

  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        attendeeRoster,
        meeting: { attendeeResponse },
        broadcastSources
      } = getState();

      const [source] = broadcastSources.sources.filter(s => s._id === sourceId);

      const action = {
        type: BROADCAST_DELETE_SOURCE,
        params: { sourceId },
        request: async apiClient => {
          const resp = await apiClient.broadcast.deleteSource(
            teamId,
            eventId,
            broadcastId,
            sourceId
          );

          // notify other directors
          socket.emit(SOURCE_DELETE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          socket.emit(ATTENDEE_ROSTER_CHANGE, {
            attendeeRoster,
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          dispatch(updateDeletedSourceInProgram(sourceId, deleteParams));
          dispatch(
            showNotification(
              `${getNotificationTitle(source)} deleted successfully`,
              {
                type: 'success'
              }
            )
          );

          return resp;
        }
      };
      dispatch(action);
    }
  );
};
